/**
 * AlertaCarga
 * @author Simpli CLI generator
 */
import {$, ID, Resource} from 'simpli-web-sdk'
import {
  ResponseSerialize,
  ValidationRequired,
} from 'simpli-web-sdk'
import Alerta from '@/model/resource/Alerta'
import Carga from '@/model/resource/Carga'
import Motorista from '@/model/resource/Motorista'
import AlertaCargaSchema from '@/schema/AlertaCarga.schema'

export default class AlertaCarga extends Resource {
  readonly $name: string = 'AlertaCarga'

  readonly $endpoint: string = '/user/alerta-carga{/id}'

  get $schema() {
    return AlertaCargaSchema(this)
  }

  get $id() {
    return this.idAlertaCargaPk
  }
  set $id(val: ID) {
    this.idAlertaCargaPk = val
  }

  @ResponseSerialize(Alerta)
  alerta: Alerta | null = null

  @ResponseSerialize(Carga)
  carga: Carga | null = null

  @ResponseSerialize(Motorista)
  motorista: Motorista | null = null

  idAlertaCargaPk: ID = 0

  @ValidationRequired()
  dataAlerta: string = ''

  get idMotoristaFk() {
    if (!this.motorista) return 0
    return this.motorista.$id
  }
  set idMotoristaFk(idMotoristaFk: ID) {
    if (!this.motorista) this.motorista = new Motorista()
    this.motorista.$id = idMotoristaFk
  }

  get idCargaFk() {
    if (!this.carga) return 0
    return this.carga.$id
  }
  set idCargaFk(idCargaFk: ID) {
    if (!this.carga) this.carga = new Carga()
    this.carga.$id = idCargaFk
  }

  get idAlertaFk() {
    if (!this.alerta) return 0
    return this.alerta.$id
  }
  set idAlertaFk(idAlertaFk: ID) {
    if (!this.alerta) this.alerta = new Alerta()
    this.alerta.$id = idAlertaFk
  }

  async persistAlertaCarga(model?: AlertaCarga, spinner = 'persistAlertaCarga') {
    const fetch = async () => {
      if (model) await model.validate()
      return await this.POST(`/user/alerta-carga`, model)
    }

    return await $.await.run(fetch, spinner)
  }

  async getAlertaCarga(id: number, spinner = 'getAlertaCarga') {
    const fetch = async () => await this.GET(`/user/alerta-carga/${id}`)
    return await $.await.run(fetch, spinner)
  }
}
